import {useMutation} from '@tanstack/react-query'
import {useSendRecaptchaTokenApiMethod} from 'api/useSendRecaptchaTokenApiMethod'
import {Params} from 'types'

export const useSendRecaptchaTokenMutation = () => {
  const sendRecaptchaToken = useSendRecaptchaTokenApiMethod()

  return useMutation({
    mutationFn: async ({order, recaptchaEnterprise}: Params.SendRecaptchaToken) => {
      return sendRecaptchaToken({
        order,
        recaptchaEnterprise,
      })
    },
  })
}
